import { useEffect, useMemo, useState } from 'react'

import LoadingPopUp from '~/components/LoadingPopUp'
import PageTitle from '~/components/PageTitle'
import { HeaderWalletBalance } from '~/modules/retailMedia/components/HeaderWalletBalance/HeaderWalletBalance'
import { WalletBalanceOrigin } from '~/modules/retailMedia/components/WalletBalanceOrigin'
import { WalletDetailSections } from '~/modules/retailMedia/components/WalletDetailSections'
import { WalletTableTransaction } from '~/modules/retailMedia/components/WalletTableTransaction'
import HeaderWallet from '~/modules/retailMedia/components/WalltetHeader'
import { useShowWalletOrigins } from '~/modules/retailMedia/hooks/useShowWalletOrigins'
import { useWalletByPair } from '~/modules/retailMedia/hooks/useWalletByPair'
import { useAppSelector } from '~/store/hooks'

const PublisherTransactions = () => {
  const showWalletOrigins = useShowWalletOrigins()
  const [shouldUpdate, setShouldUpdate] = useState(false)

  const {
    wallet,
    hasMappedOrigins,
    mappedOrigins,
    initialLoading,
    isValidating,
    mutateWallet
  } = useWalletByPair()

  const data = useMemo<DTOCheckingAccountResponse>(
    () => ({
      ...wallet,
      valueAsNumber: {
        balance: Number(wallet?.balance || 0),
        creditTotal: Number(wallet?.credit_total || 0),
        debitTotal: Number(wallet?.debit_total || 0)
      }
    }),
    [wallet]
  )

  const { loading: loadingCreateTransaction, data: responseCreateTransaction } =
    useAppSelector(state => state.retailMedia.grocery.wallet.createTransaction)

  useEffect(() => {
    if (loadingCreateTransaction) {
      setShouldUpdate(true)
    }

    const isReadyToMutate =
      !loadingCreateTransaction &&
      shouldUpdate &&
      responseCreateTransaction?.balanceAfter

    if (isReadyToMutate) {
      mutateWallet({ balance: responseCreateTransaction.balanceAfter })
      setShouldUpdate(false)
    }
  }, [
    loadingCreateTransaction,
    mutateWallet,
    responseCreateTransaction,
    shouldUpdate
  ])

  return (
    <>
      <PageTitle
        title={
          initialLoading
            ? 'Carregando...'
            : `Retal Media - ${data?.advertiser_name}`
        }
      />

      <HeaderWallet />

      <WalletDetailSections>
        <HeaderWalletBalance
          initialLoading={initialLoading}
          balance={data.valueAsNumber.balance}
          credit={data.valueAsNumber.creditTotal}
          debit={data.valueAsNumber.debitTotal}
          publisher_id={data?.publisher_id}
        />

        {showWalletOrigins && hasMappedOrigins ? (
          <WalletBalanceOrigin showHeading origins={mappedOrigins} />
        ) : null}

        <WalletTableTransaction />
      </WalletDetailSections>

      <LoadingPopUp isActive={isValidating} />
    </>
  )
}

export default PublisherTransactions
